const auth_status = {
    page_title: 'Stato di autenticazione',
    title: 'Stato di autenticazione',
    description: "Controlla lo stato dell'autenticazione.",
};
export default Object.freeze(auth_status);
